import IMask from 'imask'

class DateMask {
  constructor(inputs) {
    this.dateMask = '00/00/0000'
    this.jQuery = window.$
    this.inputs = inputs
  }

  execute() {
    this.bindElements()
  }

  bindElements() {
    this.inputs.forEach((field) => {
      const inputs = document.querySelectorAll(`[data-js="${field}"]`)

      inputs.forEach((input) => this.addInputMask(input))
    })
  }

  addInputMask(input) {
    const mask = IMask(input, { mask: this.dateMask })

    input.addEventListener('focus', () => mask.updateOptions({ lazy: false }))
    input.addEventListener('blur', () => this.hideMaskWhenIncomplete(mask))

    this.jQuery(input).on('changeDate', () => mask.updateValue())
  }

  hideMaskWhenIncomplete(mask) {
    const inputMask = mask

    if (!inputMask.masked.isComplete) inputMask.value = ''

    inputMask.updateOptions({ lazy: true })
  }
}

export default DateMask
